import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminOrders, adminUpdateOrder, adminDeleteOrder, adminOrderInvoice, adminDownloadOrdersCsv, formatRON } from "@/lib/api";

const STATUSES = ["received", "processing", "shipped", "delivered", "cancelled"];

const OrdersAdmin = () => {
  const [orders, setOrders] = useState([]);
  const load = async () => setOrders(await adminOrders());
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    try { await adminUpdateOrder(id, status); setOrders((o) => o.map((x) => (x.id === id ? { ...x, status } : x))); toast.success("Status actualizat"); }
    catch { toast.error("Eroare"); }
  };

  const removeOrder = async (id) => {
    if (!window.confirm("Ștergi această comandă definitiv?")) return;
    try { await adminDeleteOrder(id); setOrders((o) => o.filter((x) => x.id !== id)); toast.success("Comandă ștearsă"); }
    catch { toast.error("Eroare"); }
  };

  const [invoiceBusy, setInvoiceBusy] = useState("");
  const getInvoice = async (id) => {
    setInvoiceBusy(id);
    try {
      const d = await adminOrderInvoice(id);
      setOrders((o) => o.map((x) => (x.id === id ? { ...x, invoice: d.invoice, invoice_status: d.invoice_status } : x)));
      if (d.invoice?.link) window.open(d.invoice.link, "_blank");
      else toast.success("Factură emisă");
    } catch (e) { toast.error(e?.response?.data?.detail || "Eroare FGO"); }
    finally { setInvoiceBusy(""); }
  };

  return (
    <div className="p-5 sm:p-8" data-testid="orders-admin">
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-xl uc font-semibold">Comenzi [{orders.length}]</h2>
        <button onClick={adminDownloadOrdersCsv} data-testid="orders-csv" className="border border-border px-4 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-foreground hover:text-white">Export CSV</button>
      </div>
      {orders.length === 0 ? <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Nicio comandă.</p> : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="border border-border p-4" data-testid={`order-row-${o.order_number}`}>
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <span className="font-mono text-sm uppercase tracking-widest">{o.order_number}</span>
                  <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{o.customer.name} · {o.customer.city} · {o.customer.phone}</div>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-mono text-sm">{formatRON(o.total)}</span>
                  <select value={o.status} onChange={(e) => changeStatus(o.id, e.target.value)} data-testid={`order-status-${o.order_number}`}
                    className="border border-border px-2 py-1 font-mono text-[11px] uppercase tracking-widest focus:outline-none">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                  <button onClick={() => removeOrder(o.id)} data-testid={`order-delete-${o.order_number}`} className="font-mono text-xs text-destructive hover:opacity-70">×</button>
                </div>
              </div>
              <div className="mt-2 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                {o.items.map((i) => `${i.name} ${i.size}/${i.color} ×${i.qty}`).join(" · ")}{o.voucher ? ` · [${o.voucher} -${o.discount} lei]` : ""}
              </div>
              <div className="mt-2 flex items-center gap-3 font-mono text-[11px] uppercase tracking-widest" data-testid={`order-invoice-${o.order_number}`}>
                {o.invoice?.number ? (
                  <>
                    <span className="text-foreground">Factura {o.invoice.series}{o.invoice.number}</span>
                    {o.invoice.link && <a href={o.invoice.link} target="_blank" rel="noreferrer" className="underline" data-testid={`order-invoice-link-${o.order_number}`}>PDF</a>}
                  </>
                ) : (
                  <button onClick={() => getInvoice(o.id)} disabled={invoiceBusy === o.id} data-testid={`order-invoice-btn-${o.order_number}`} className="border border-border px-2 py-1 hover:bg-foreground hover:text-white disabled:opacity-50">
                    {invoiceBusy === o.id ? "Se emite…" : (o.invoice_status === "failed" ? "Reîncearcă factura" : "Emite factura")}
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrdersAdmin;
